import type { MainBanner } from "~/core";

export const isMainBanner = (item: unknown): item is MainBanner => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "main_banner" &&
    "items" in item &&
    item.items !== null
  );
};
